<template>
  <el-row>
    <el-row v-if="showFile || false"
            class="mag">
      <el-input placeholder="输入关键字进行过滤"
                v-model="filterText">
      </el-input>
    </el-row>
    <el-row class="mag tree">
      <el-tree ref="tree"
               :data.sync="TreeData"
               @node-expand="loadNode"
               :props="props"
               node-key="id"
               :default-checked-keys="defaultCheck"
               :filter-node-method="filterNode"
               highlight-current
               show-checkbox>
      </el-tree>
    </el-row>
    <el-row class="btn mag">
      <el-button type="primary"
                 @click="Save()">确定</el-button>
      <el-button @click="Out()">取消</el-button>
    </el-row>
  </el-row>

</template>
<script>
export default {
  data () {
    return {
      filterText: "",
    }
  },
  props: {
    TreeData: { type: Array, default () { return []; } },
    defaultCheck: { type: Array, default () { return []; } },
    props: { type: Object, default () { return { id: "id", label: 'label', children: 'children' }; } },
    showFile: { type: Boolean, default: false },
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode (value, data, node) {
      if (!value) return true;
      if (!data.label) return false;
      return data.label.indexOf(value) !== -1;
    },
    loadNode (data, node) {
      this.$emit('loadNode', data, node)
    },
    Save () {
      var check = this.$refs.tree.getCheckedNodes();
      this.$emit('TreeSave', check)
    },
    Out () {
      this.$emit('TreeOut')
    }
  },
}
</script>
<style scoped>
.mag {
  margin-top: 20px;
}
.tree {
  min-height: 300px;
  max-height: 500px;
  overflow-y: auto;
}
</style>

